import { render, staticRenderFns } from "./coachUploadMediaAudit.vue?vue&type=template&id=12ccd173&scoped=true"
import script from "./coachUploadMediaAudit.vue?vue&type=script&lang=ts"
export * from "./coachUploadMediaAudit.vue?vue&type=script&lang=ts"
import style0 from "./coachUploadMediaAudit.vue?vue&type=style&index=0&id=12ccd173&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ccd173",
  null
  
)

export default component.exports